import { createRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

const bookingCreateSearchSchema = z.object({
  quoteSheetID: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  manualQuoteID: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  customerRequestedQuoteID: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  selectedQuoteID: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  bookAgainFromShipmentCode: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  bookAgainFromBookingID: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
})

export const bookingsCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bookings/create',
  validateSearch: bookingCreateSearchSchema,
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (context.isReady && !context.isCustomerActive) {
      throw redirect({
        to: '/',
      })
    }
  },
}).lazy(() => import('../components/BookingCreateRoot').then((d) => d.Route))
